<div class="row page-header">
    <div class="col-12">
        <h1>Holds &amp; Constraints <small>(Beta)</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group me-3 mb-2">
                    <label class="me-2" for="fabHoldJobSelect">Job</label>
                    <wj-combo-box
                        id="fabHoldJobSelect"
                        name="fabHoldJobSelect"
                        [(ngModel)]="selectedJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (selectedIndexChanged)="onJobChanged()"
                        style="width: 22rem"
                    ></wj-combo-box>
                </div>
                <div class="form-group form-check me-3 mb-2">
                    <input
                        id="includeReleased"
                        name="includeReleased"
                        type="checkbox"
                        class="form-check-input"
                        [(ngModel)]="includeReleased"
                        (ngModelChange)="onIncludeReleasedChanged()"
                    />
                    <label class="form-check-label" for="includeReleased">Include released</label>
                </div>
                <span class="badge bg-secondary me-2 mb-2">Open: {{ openCount }}</span>
                <span class="badge bg-danger me-3 mb-2">Overdue release: {{ overdueReleaseCount }}</span>
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <action-toolbar-buttons
                    [grid]="grid"
                    [canEdit]="canEdit"
                    [showAdd]="true"
                    [showEdit]="true"
                    [showDelete]="true"
                ></action-toolbar-buttons>
                @if (canEdit) {
                    <button type="button" class="btn btn-sm btn-secondary mb-2 me-2" (click)="releaseSelected()">Release</button>
                }
                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <wj-flex-grid
                id="mainGrid"
                #mainGrid
                appAutoSize
                (initialized)="grid.initialize(mainGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
                [itemFormatter]="formatItem"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplayName'" [width]="140"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'DWG #'" [binding]="'markCode'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Piece'" [binding]="'pieceName'" [width]="'*'" [minWidth]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Reason'" [binding]="'reasonName'" [width]="180"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Owner'"
                    [binding]="'ownerUserId'"
                    [width]="140"
                    [dataMap]="userMap"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Step'" [binding]="'processStepName'" [width]="160"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Started'"
                    [binding]="'startedOn'"
                    [width]="100"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Expected Release'"
                    [binding]="'expectedReleaseDate'"
                    [width]="120"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Days Held'" [binding]="'daysHeld'" [width]="90" [align]="'center'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Released'"
                    [binding]="'releasedOn'"
                    [width]="100"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
    </div>
</div>
